import React, { useState } from "react";
import styles from "./home.module.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const VideoSlider = () => {
  const [isMuted, setIsMuted] = useState(true);

  const handleMuteToggle = () => {
    setIsMuted((prev) => !prev);
  };

  return (
    <div className={styles.video_container}>
      <Carousel
        showArrows={false}
        infiniteLoop={true}
        showThumbs={false}
        showIndicators={true}
        showStatus={false}
        dynamicHeight={true}
        autoPlay={false}
        interval={5000}
        transitionTime={500}
      >
        <div className={styles.video_container} onClick={handleMuteToggle}>
          <video
            className={styles.video_player}
            controls
            muted={isMuted}
            autoPlay={false}
            // width="100px"
            // height="100%"
            style={{ borderRadius: "40px" }}
          >
            <source
              src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className={styles.video_container} onClick={handleMuteToggle}>
          <video
            className={styles.video_player}
            controls
            muted={isMuted}
            autoPlay={false}
            // width="1000px"
            // height="100%"
            style={{ borderRadius: "40px" }}
          >
            <source
              src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className={styles.video_container} onClick={handleMuteToggle}>
          <video
            className={styles.video_player}
            controls
            muted={isMuted}
            autoPlay={false}
            // width="1000px"
            // height="100%"
            style={{ borderRadius: "40px" }}
          >
            <source
              src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </Carousel>
    </div>
  );
};

export default VideoSlider;
